import placeholderAvatar from "../assets/images/img-profile.png";
import { useEffect } from "react";
import { useProfile } from "../hooks/context/useProfile";
import { areDefined, isDefined } from "../utils/validation";
import { fomratResponseData } from "../utils/fomratResponseData";
import { useProfileQuery } from "../hooks/services/profile/useProfileQuery";

const ProfileWidget = () => {
  // Hook Profile Query
  const { profileData, isPending } = useProfileQuery();
  // Profile Context API
  const { profile, setProfile } = useProfile();

  useEffect(() => {
    // Loading Profile data (avatar, infos...)
    if (!isPending) {
      const profile = fomratResponseData({ responseData: profileData, requestKey: "getProfile" });
      setProfile((prev) => ({ ...prev, ...profile }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profileData, isPending]);

  return (
    <div className="d-flex">
      <div className="image-profile">
        <img alt="avatar" src={profile?.avatar || placeholderAvatar} />
      </div>

      <div className="bloc-name-profile">
        <span className="name-profile">
          {areDefined(profile?.first_name, profile?.last_name)
            ? `${profile?.first_name} ${profile?.last_name}`
            : "Profile Name..."}
        </span>
        <span className="statut-profile">ID: {isDefined(profile?.id) ? profile?.id : "..."}</span>
      </div>
    </div>
  );
};

export default ProfileWidget;
